import { render, staticRenderFns } from "./AdditionalCostsInput.vue?vue&type=template&id=06de3eb0&scoped=true&"
import script from "./AdditionalCostsInput.vue?vue&type=script&lang=js&"
export * from "./AdditionalCostsInput.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalCostsInput.vue?vue&type=style&index=0&id=06de3eb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06de3eb0",
  null
  
)

export default component.exports